// extracted by mini-css-extract-plugin
export default {"tableContainer":"SimpleDataTable_tableContainer__9s+ME"};